import {
    GET_WELCOME,
    GET_STATE_LOADING
} from "@/views/home/store/types/types.js";

const getters = {
    [GET_WELCOME]: state => state.welcome,
    [GET_STATE_LOADING]: state => state.loading,
};

export default getters;